import axios, { AxiosRequestConfig } from 'axios'

import { API_URL } from '../constants/urls'

export const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 30000
})

apiClient.interceptors.request.use((config: AxiosRequestConfig) => {
  const token = localStorage.getItem('token')

  const newConfig = config
  if (token) {
    newConfig.headers = {
      ...(newConfig.headers ?? {}),
      'api-key': token,
      'x-mail-auth': localStorage.getItem('auth') || 'false'
    }
  }
  return newConfig
})

export default apiClient
